import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=508c9b6c&scoped=true&"
import script from "./TopPage.vue?vue&type=script&lang=js&"
export * from "./TopPage.vue?vue&type=script&lang=js&"
import style0 from "./TopPage.vue?vue&type=style&index=0&id=508c9b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c9b6c",
  null
  
)

export default component.exports